import { ApiService } from "../apiService";

export class FilesService extends ApiService {
    constructor() {
        super();
        
        this.path = '/Files';
    }

    deleteFile(id) {
        return this.delete(this.path + "/deleteFile", id);
    }


    saveFileFW(file){
        return this.saveFile(this.path + "/saveFileFW", file);
    }

    getFilesAdm(){
        return this.get(this.path + "/getFiles");
    }

    updateFile(id){
        return this.postUndo(this.path + "/undoDeleteFile", id);
    }


}